// Constants use for the path param of files queries
export const FILE_TYPES = {
    CHARACTER: 'character',
    MAP: 'map',
    CAMPAIGN: 'campaign',
    PROFILE: 'profile',
} as const;

export type FileType = (typeof FILE_TYPES)[keyof typeof FILE_TYPES];
